import React from 'react';

import { isDingtalk } from '@/constants/common';
import { getI18n } from '@/utils/i18n';

import styles from './index.cm.styl';
import publicSecurityIconPng from '@/static/images/publicSecurityIcon.png';

const i18n = getI18n();
const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.licenseTextRow}>
        <img
          className={styles.publicSecurityIcon}
          width={16}
          height={16}
          src={publicSecurityIconPng}
        />
        {isDingtalk ? (
          <div className={styles.licenseText}>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002010140"
              target="_blank"
            >
              {i18n.t`浙公网安备 33011002010140号`}
            </a>
            <a href="https://beian.miit.gov.cn" target="_blank">
              {i18n.t`浙ICP备18037475号-1`}
            </a>
          </div>
        ) : (
          <div className={styles.licenseText}>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802024479"
              target="_blank"
            >
              {i18n.t`京公网安备 11010802024479号`}
            </a>
            <a href="https://beian.miit.gov.cn" target="_blank">
              {i18n.t`京ICP备15060035号-3`}
            </a>
          </div>
        )}
      </div>
      <div className={styles.poweredBy}>
        <a className={styles.poweredByImg} href="https://www.mokahr.com/" target="_blank" />
      </div>
    </div>
  );
};

export default Footer;
